export default "__VITE_ASSET___3dKkWoc__"